import React from 'react'
import { FormattedMessage, injectIntl, intlShape } from 'react-intl'

const BookingInsuranceForm = ({ intl }) => (
  <div>
    <div className="">
      <h2>
        <FormattedMessage id="booking.insurance.cancellation.header" />
      </h2>
      <p>
        <ul>
          <li>
            <FormattedMessage id="booking.insurance.cancellation.bullet1" />
          </li>
          <li>
            <FormattedMessage id="booking.insurance.cancellation.bullet2" />
          </li>
        </ul>
      </p>
      <p>
        <FormattedMessage id="booking.insurance.cancellation.descLn1" />
      </p>
      <p>
        <FormattedMessage
          id="booking.insurance.cancellation.descLn2"
          values={{
            link: (
              <a
                href={intl.formatMessage({ id: 'booking.insurance.cancellation.linkUrl' })}
                target='_blank'
                rel="noopener noreferrer" 
                className="text-harbor underline"
              >
                <FormattedMessage id="booking.insurance.cancellation.linkText" />
              </a>
            )
          }} 
        />
      </p>
    </div>
  </div>
)

BookingInsuranceForm.propTypes = {
  intl: intlShape.isRequired
}
BookingInsuranceForm.defaultProps = {}

export default injectIntl(BookingInsuranceForm)